var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{attrs:{"relative":false,"theme":_vm.menuTheme,"hideToggle":true,"collapsed":_vm.collapsedProp,"width":"250px","menu":_vm.menu,"showOneChild":true},on:{"toggle-collapse":_vm.onToggleCollapse,"item-click":_vm.onItemClick}})}
var staticRenderFns = []

export { render, staticRenderFns }